"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var DeviceType_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemUserAgent/DeviceType"));
var ClientName_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemUserAgent/ClientName"));
var Os_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemUserAgent/Os"));
var CpuArch_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemUserAgent/CpuArch"));
function UserAgent(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var job = _a.job, domain = _a.domain, templateIndex = _a.templateIndex;
    var t = (0, react_i18next_1.useTranslation)().t;
    var agent = (_c = (_b = job.ad) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.meta.agent;
    var shouldShowUserAgent = ((_d = agent === null || agent === void 0 ? void 0 : agent.device) === null || _d === void 0 ? void 0 : _d.type) ||
        ((_e = agent === null || agent === void 0 ? void 0 : agent.device) === null || _e === void 0 ? void 0 : _e.model) ||
        ((_f = agent === null || agent === void 0 ? void 0 : agent.device) === null || _f === void 0 ? void 0 : _f.brand) ||
        ((_g = agent === null || agent === void 0 ? void 0 : agent.client) === null || _g === void 0 ? void 0 : _g.name) ||
        ((_h = agent === null || agent === void 0 ? void 0 : agent.os) === null || _h === void 0 ? void 0 : _h.family) ||
        ((_j = agent === null || agent === void 0 ? void 0 : agent.os) === null || _j === void 0 ? void 0 : _j.version) ||
        ((_k = agent === null || agent === void 0 ? void 0 : agent.cpu) === null || _k === void 0 ? void 0 : _k.architecture);
    if (!shouldShowUserAgent || templateIndex < 0) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "eva-job-other-information-section", style: { order: templateIndex } },
        react_1.default.createElement("h4", null, t('ITEM.USER_AGENT')),
        react_1.default.createElement(DeviceType_1.default, { job: job, domain: domain }),
        react_1.default.createElement(ClientName_1.default, { job: job, domain: domain }),
        react_1.default.createElement(Os_1.default, { job: job, domain: domain }),
        react_1.default.createElement(CpuArch_1.default, { job: job, domain: domain })));
}
exports.default = UserAgent;
